
import { Elements } from "@stripe/react-stripe-js";
import PaymentForm from "../../components/stripe/PaymentForm";



const PaymentScreenContent = ({
    paymentMethodArr,
    makeDefault,
    handleDeleteCard,
    cardHolderToggle,
    setcardHolderToggle,
    cardHolderName,
    setcardHolderName,
    userProfileInfo,
    setAddStripe,
    setstripeLoader,
    buttonClicked2,
    setButtonClicked2,
    stripeTestPromise,
    stripeloader
}) => (
    <div className="flex-1 flex justify-center items-start bg-transparent">
        <div className="w-full max-w-4xl rounded-2xl pb-8 md:pb-10 md:px-10">
            <div className="text-2xl font-bold mb-8 text-gray-900 tracking-tight">Payment method</div>
            <div className="mb-4">
                <div className="text-base font-semibold text-gray-700 mb-1">Save card for future use</div>
                <div className="text-xs text-gray-500 mb-2">Manage your payment method here for future bookings.</div>
                {paymentMethodArr?.length > 0 && (
                    <div className="rounded-2xl border border-gray-200 overflow-hidden bg-white shadow-sm">
                        <div className="flex px-5 py-3 bg-gray-100 font-semibold text-gray-700 text-sm uppercase tracking-wide">
                            <div className="flex-1">Card</div>
                            <div className="w-28 text-center">Default</div>
                            <div className="w-28 text-center">Delete</div>
                        </div>
                        {paymentMethodArr?.map((paymentMethod) => (
                            <div
                                key={paymentMethod?.stripeCardId}
                                className="flex items-center px-5 py-4 border-t border-gray-100 text-sm hover:bg-gray-50 transition-colors duration-200"
                            >
                                <div className="flex-1 font-mono text-gray-900">
                                    **** **** **** {paymentMethod?.stripeCardLastFourDigits}
                                </div>
                                <div className="w-28 text-center">
                                    <input
                                        type="checkbox"
                                        checked={paymentMethod?.isDefault}
                                        onChange={(e) => makeDefault(e, paymentMethod?.stripeCardId)}
                                        className="accent-indigo-600 w-5 h-5 cursor-pointer"
                                    />
                                </div>
                                <div className="w-28 text-center">
                                    <span
                                        className="text-red-500 hover:text-red-600 cursor-pointer transition-colors duration-200"
                                        onClick={() => handleDeleteCard(paymentMethod?.stripeCardId)}
                                    >
                                        <i className="fas fa-trash-alt"></i>
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

            </div>
            <div className="mb-3">
                <div className="text-xs font-semibold text-gray-600 mb-1">Card Holder's Name</div>
                <div className="flex items-center bg-[#F6F6FD] rounded-lg px-3 py-2 border border-gray-200">
                    {!cardHolderToggle ? (
                        <span className="text-gray-900 font-medium flex-1">{cardHolderName ? cardHolderName : (userProfileInfo?.firstName ? userProfileInfo.firstName + (userProfileInfo.lastName ? ' ' + userProfileInfo.lastName : '') : "Card Holder's Name")}</span>
                    ) : (
                        <input
                            value={cardHolderName || (userProfileInfo?.firstName ? userProfileInfo.firstName + (userProfileInfo.lastName ? ' ' + userProfileInfo.lastName : '') : "")}
                            onChange={(e) => setcardHolderName(e.target.value)}
                            className="bg-transparent outline-none w-full text-gray-900 font-medium flex-1"
                            placeholder="Card Holder's Name"
                        />
                    )}
                    <span
                        className={`ml-3 cursor-pointer ${cardHolderToggle ? 'text-gray-400' : 'text-blue-600'}`}
                        onClick={() => setcardHolderToggle(!cardHolderToggle)}
                    >
                        <i className="far fa-edit"></i>
                    </span>
                </div>
            </div>
            <div className="mb-2">
                <Elements stripe={stripeTestPromise}>
                    <PaymentForm
                        userId={userProfileInfo?.id}
                        setAddStripe={setAddStripe}
                        setstripeLoader={{
                            loading: stripeloader,
                            set: setstripeLoader
                        }}
                        submitWrapper={(cb, e) => {
                            e.preventDefault();
                            if (!buttonClicked2) {
                                setButtonClicked2(true);
                                cb(e);
                            }
                        }}
                    />
                </Elements>
            </div>
        </div>
    </div>
);

export default PaymentScreenContent;
